import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { Auth } from 'src/app/models/auth';
import { StatusBatch } from 'src/app/models/colaborador-batch';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-colaborador-arquivo-confirmar',
  templateUrl: './colaborador-arquivo-confirmar.component.html',
  styleUrls: ['./colaborador-arquivo-confirmar.component.css']
})
export class ColaboradorArquivoConfirmarComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private colaboradorService: ColaboradorService,
    private alertService: NewAlertService,
    private authenticationService: AuthenticationService
  ) { }

  public currentUser: Auth;
  private id: number;
  private routeSubscription: Subscription;
  public sub: Subscription;
  public progressBarValue: number = 0;
  public status = new StatusBatch(0, 0, 0);
  public processed: boolean = false;

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;

    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.id = +params.get('id');

      if (this.id > 0) this.getStatus(this.id)
    });
  }

  getStatus(id: any) {
    const options = {
      autoClose: true,
      keepAfterRouteChange: true
    };

    this.sub = timer(0, 5000).pipe(
      map(() => {
        this.colaboradorService.getStatusBatch(id, this.currentUser.token.assignorGuid)
          .subscribe(
            response => {
              if (response.status == ApiError.Sucesso) {

                console.log(response.result)

                this.status = response.result;

                let progress = (this.status.processada / this.status.total) * 100;
                this.progressBarValue = progress > 100 ? 100 : progress;

                if (this.status.total <= this.status.processada) {

                  this.alertService.notificationSuccess(
                    "Cadastro de favorecidos",
                    "Cadastros processados",
                    options
                  );

                  this.processed = true;
                  this.sub.unsubscribe();
                }
              }
              else {
                this.sub.unsubscribe();
                this.alertService.error(response.message);
              }
            }, error => { console.log(error) }
          ) // load data contains the http request
      })
    ).subscribe();
  }

  baixarErros() {
    this.colaboradorService.getBatchErrors(this.id, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          saveAs(response.result, "Template-Favorecido-Erro");
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
  }

  cardsBacth() {
    this.colaboradorService.getCollaboratorsBatch(this.id, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.colaboradorService.setCurrentCollaboratorIds(response.result);
          this.router.navigate(['cartao-lote'], { relativeTo: this.route.parent });
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
